import React, { useState } from 'react';
import { ChevronDownIcon, MinusIcon, PlusIcon, ShieldCheckIcon } from 'lucide-react';
import { pricingConfig } from '../../data/pricing';
import { useFunnel } from '../../contexts/FunnelContext';
import { formatMoney, priceBundle } from '../../utils/pricing';
import { orderTotals } from '../../utils/checkout';
const m = (n: number) => formatMoney(n, 'en');

/** "Add another system to my order" — keeps the selected system and adds complete Shopify bundles. */
export function AddSystemPanel() {
  const {
    state,
    order,
    addSystem,
    setAddOnQty
  } = useFunnel();
  const [open, setOpen] = useState(false);
  if (!state) return null;
  const current = orderTotals(order).total;
  const addCount = state.addOns.reduce((n, l) => n + l.qty, 0);
  return <div className="border border-white/15 bg-[#06121F]" data-id="element-62" data-mp="obbw2u90aci0">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex min-h-[56px] w-full items-center justify-between gap-3 px-5 py-3 text-left" data-id="element-63" data-mp="1usz1540kli8x">
        <span data-id="element-64" data-mp="350w1ekqape3c">
          <span className="block font-display text-lg font-semibold uppercase tracking-[0.04em] text-white" data-id="element-65" data-mp="34zcnv1w0xh59">
            Add another system to my order
          </span>
          <span className="block text-sm text-titanium" data-id="element-66" data-mp="2vzfr0czhdbz4">
            {addCount ? `${addCount} added · ` : ''}Keep your system and light another area.
          </span>
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-titanium transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden data-id="element-67" data-mp="2m3uuuvh3f5xa" />
      </button>

      {open && <ul className="divide-y divide-white/10 border-t border-white/10" data-id="element-68" data-mp="2dbavfssz8xbe">
          {pricingConfig.bundles.map(b => {
        const p = priceBundle(b);
        const qty = state.addOns.find(l => l.bundleId === b.id)?.qty ?? 0;
        return <li key={b.id} className="flex items-center gap-3 px-4 py-3" data-id="element-69" data-mp="1ycqjjnm0e75v">
                <img src={b.image} alt="" loading="lazy" className="aspect-[1122/1402] w-11 shrink-0 object-cover" data-id="element-70" data-mp="1yfl6blshw42g" />
                <div className="min-w-0 flex-1" data-id="element-71" data-mp="1tog2q6ct4pkt">
                  <p className="truncate font-display text-[15px] font-semibold uppercase tracking-[0.03em] text-white" data-id="element-72" data-mp="1tqajd8h1pvj3">
                    {b.tagline} · {b.qty} {b.qty === 1 ? 'light' : 'lights'}
                  </p>
                  <p className="text-[13px] text-titanium" data-id="element-73" data-mp="1jsmh7xh41lqw">
                    <span className="text-white" data-id="element-74" data-mp="27hfdxw5k3xmk">{m(p.total)}</span> · {m(p.perUnit)}/light
                  </p>
                  <p className="flex items-center gap-1 text-[12px] text-titanium" data-id="element-75" data-mp="2cepdw5qknron">
                    <ShieldCheckIcon className={`h-3.5 w-3.5 ${b.warranty === 'lifetime' ? 'text-marine' : ''}`} aria-hidden data-id="element-76" data-mp="1yn11e1cev175" />
                    {b.warranty === 'lifetime' ? 'Lifetime' : '1-year'} · new subtotal {m(current + p.total)}
                  </p>
                </div>
                {qty > 0 ? <div className="flex shrink-0 items-center border border-marine/60" data-id="element-77" data-mp="2v79pmae53g58">
                    <button type="button" onClick={() => setAddOnQty(b.id, qty - 1)} aria-label={`Remove one ${b.tagline}`} className="flex h-11 w-11 items-center justify-center text-white hover:bg-white/5" data-id="element-78" data-mp="jpexdu0wt2t6">
                      <MinusIcon className="h-4 w-4" aria-hidden data-id="element-79" data-mp="ohy7ui4avhtr" />
                    </button>
                    <span className="w-7 text-center font-semibold text-white" aria-live="polite" data-id="element-80" data-mp="sdohy48iijy">
                      {qty}
                    </span>
                    <button type="button" onClick={() => addSystem(b.id)} aria-label={`Add another ${b.tagline}`} className="flex h-11 w-11 items-center justify-center text-white hover:bg-white/5" data-id="element-81" data-mp="aqkslgdfd64j">
                      <PlusIcon className="h-4 w-4" aria-hidden data-id="element-82" data-mp="1h6n689dz191t" />
                    </button>
                  </div> : <button type="button" onClick={() => addSystem(b.id)} className="inline-flex h-11 shrink-0 items-center gap-1 rounded-md border border-titanium/30 px-3 font-display text-[14px] font-semibold uppercase tracking-[0.1em] text-white transition-colors duration-150 hover:border-white hover:bg-white/5" data-id="element-83" data-mp="3mvyy5l8jczwx">
                    <PlusIcon className="h-4 w-4" aria-hidden data-id="element-84" data-mp="9ncj509bxcc8" /> Add
                  </button>}
              </li>;
      })}
        </ul>}
    </div>;
}